import { useSiteGeocodingIssues } from '@/routes/map/SitesMapPage.hooks'
import RequeueSiteGeocodingButton from '@/components/site-geocoding/RequeueSiteGeocodingButton'
import type { SiteGeocodingIssues } from '@/routes/map/SitesMapPage.types'
import { Popup } from 'devextreme-react/popup'
import { DataGrid, Column, Paging, Pager, SearchPanel } from 'devextreme-react/data-grid'
import { Button } from 'devextreme-react/button'
import { useCallback } from 'react'

const STATUS_LABELS: Record<string, string> = {
  pending: 'In attesa',
  warning: 'Indirizzo incompleto',
  failed: 'Geocoding fallito o non affidabile',
  ok: 'Coordinate mancanti',
  manual: 'Coordinate manuali mancanti',
}

type GeocodingIssue = SiteGeocodingIssues['items'][number]

const renderRequeue = ({ data }: { data: GeocodingIssue }) => (
  <RequeueSiteGeocodingButton
    key={`${data.siteId}-${data.status}-${data.updatedAt}`}
    siteId={data.siteId}
    canRequeue={data.canRequeue}
    hasCoordinates={data.hasCoordinates}
  />
)
const renderOpenSite = ({ data }: { data: GeocodingIssue }) =>
  data.companyId ? (
    <a href={`/clients/${data.companyId}/sites`} target="_blank" rel="noreferrer">
      Apri sede
    </a>
  ) : null
const formatStatus = ({ value }: { value?: string | number | Date }) => STATUS_LABELS[String(value)] ?? String(value)

const SitesMapGeocodingIssues = ({ opened, onClose }: { opened: boolean; onClose: () => void }) => {
  const issues = useSiteGeocodingIssues(opened)
  const { refetch } = issues
  const refresh = useCallback(async () => {
    await refetch()
  }, [refetch])
  return (
    <Popup
      visible={opened}
      onHiding={onClose}
      title="Sedi da geocodificare"
      showCloseButton
      width="95vw"
      maxWidth={1100}
      height="80vh"
    >
      {issues.isLoading && <p>Caricamento sedi...</p>}
      {issues.error && <p>Impossibile caricare le sedi da correggere.</p>}
      {issues.data && (
        <>
          <p>
            {issues.data.notGeocodedCount} sedi attive da verificare. Apri la sede per correggere l’indirizzo oppure
            rimettila in coda per il prossimo job.
          </p>
          <Button text="Aggiorna" icon="refresh" onClick={refresh} />
          <DataGrid
            dataSource={issues.data.items}
            keyExpr="siteId"
            height="calc(100% - 110px)"
            columnAutoWidth
            columnHidingEnabled
            noDataText="Nessuna sede da correggere"
          >
            <SearchPanel visible />
            <Paging pageSize={20} />
            <Pager visible showInfo showNavigationButtons />
            <Column dataField="companyName" caption="Azienda" />
            <Column dataField="siteName" caption="Sede" />
            <Column dataField="address" caption="Indirizzo" />
            <Column dataField="status" caption="Stato" customizeText={formatStatus} />
            <Column dataField="updatedAt" caption="Ultimo tentativo" dataType="datetime" />
            <Column caption="Geocodifica" cellRender={renderRequeue} allowSorting={false} />
            <Column caption="Apri" cellRender={renderOpenSite} />
          </DataGrid>
        </>
      )}
    </Popup>
  )
}

export default SitesMapGeocodingIssues
